import React from "react";

import PatentForm from "../components/forms/startup/Cdocument"

export default function ErdalPage() {
  return (
    <div>
      <PatentForm  />

    </div>
  );
}
